import {
  AddIcon,
  Button,
  EmptyState,
  ListPanel,
  MeetingList,
  MeetingListItemSkeleton,
  Stack,
  Typography,
} from '@all-manager/design-system-v2';
import FullPageLayout from '../../../layout/FullPageLayout/FullPageLayout';
import NoMeetingsIcon from '../assets/no-meetings.svg?react';
import MeetingRow from '../components/MeetingRow/MeetingRow';
import { CreateUpdateMeetingModal } from '../components/modals/CreateUpdateMeetingModal';
import { useMeetingsPage } from './useMeetingsPage';

const SKELETON_ROWS = [0, 1, 2, 3];
const UPCOMING_HEADING_ID = 'meetings-upcoming';
const PAST_HEADING_ID = 'meetings-past';
const SECTION_HEADING_MAPPING = { h5: 'h2' };

export default function MeetingsPage() {
  const hook = useMeetingsPage();

  return (
    <>
      <FullPageLayout
        htmlTitle="Réunions"
        title="Réunions"
        action={hook.isAdmin ? (
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={hook.handleOpenCreateModal}
          >
            Nouvelle réunion
          </Button>
        ) : undefined}
      >
        {hook.isError ? (
          <ListPanel>
            <EmptyState
              title="Réunions indisponibles"
              subtitle="Le chargement a échoué. Rechargez la page pour réessayer."
            />
          </ListPanel>
        ) : hook.isLoading ? (
          <ListPanel>
            <MeetingList aria-label="Réunions" aria-busy>
              {SKELETON_ROWS.map((row) => <MeetingListItemSkeleton key={row} />)}
            </MeetingList>
          </ListPanel>
        ) : hook.isEmpty ? (
          <EmptyState
            title="Aucune réunion"
            subtitle="Les réunions du conseil syndical, leur ordre du jour et leur compte rendu apparaîtront ici."
            image={<NoMeetingsIcon />}
          />
        ) : (
          <Stack spacing={3}>
            <section aria-labelledby={UPCOMING_HEADING_ID}>
              <Stack spacing={1}>
                <Typography variant="h5" variantMapping={SECTION_HEADING_MAPPING} id={UPCOMING_HEADING_ID}>
                  À venir
                </Typography>
                <ListPanel>
                  {hook.upcoming.length > 0 ? (
                    <MeetingList aria-label="Réunions à venir">
                      {hook.upcoming.map((meeting) => (
                        <MeetingRow key={meeting.id} meeting={meeting} upcoming />
                      ))}
                    </MeetingList>
                  ) : (
                    <EmptyState
                      title="Aucune réunion programmée"
                      subtitle="La prochaine réunion du conseil syndical apparaîtra ici dès qu'elle sera planifiée."
                    />
                  )}
                </ListPanel>
              </Stack>
            </section>

            {hook.pastByYear.length > 0 ? (
              <section aria-labelledby={PAST_HEADING_ID}>
                <Stack spacing={1}>
                  <Typography variant="h5" variantMapping={SECTION_HEADING_MAPPING} id={PAST_HEADING_ID}>
                    Passées
                  </Typography>
                  <ListPanel>
                    {hook.pastByYear.map((group) => (
                      <MeetingList key={group.year} title={group.year}>
                        {group.meetings.map((meeting) => (
                          <MeetingRow key={meeting.id} meeting={meeting} />
                        ))}
                      </MeetingList>
                    ))}
                  </ListPanel>
                </Stack>
              </section>
            ) : null}
          </Stack>
        )}
      </FullPageLayout>

      {hook.isCreateModalOpen ? (
        <CreateUpdateMeetingModal onClose={hook.handleCloseCreateModal} />
      ) : null}
    </>
  );
}
